// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ZaHtvBpzOCki7lSdqGudJ","loadingText":"_1zEhadh-q_WJxhrUi2dCN9","dot":"_3T-z-2Iy8NqZPZGhlEMi8A","animate":"_3H9zptqHTr26kSwHCcMuvM"};